import { Button } from 'flowbite-react';
import { Icon } from '../component/Icon';
import type { TooltipRenderProps } from 'react-joyride';

export const TourTooltip = ({
  continuous,
  index,
  step,
  backProps,
  closeProps,
  primaryProps,
  skipProps,
  tooltipProps,
  size,
  isLastStep,
}: TooltipRenderProps) => {
  return (
    <div
      {...tooltipProps}
      className="max-w-sm rounded-3xl bg-white p-5 shadow-lg font-sans"
    >
      {/* Close button */}
      <button
        {...closeProps}
        className="absolute top-3 right-3 p-1 text-blackLight hover:text-greyDark rounded-full hover:bg-greyLightest transition-colors"
        aria-label="Close tour"
      >
        <Icon name="x" className="h-4 w-4" />
      </button>

      {/* Title */}
      {step.title && (
        <h3 className="text-primary-700 text-lg font-semibold mb-2 pr-6">
          {step.title}
        </h3>
      )}

      {/* Content */}
      <p className="text-blackLight text-sm leading-relaxed">{step.content}</p>

      {/* Footer */}
      <div className="flex items-center justify-between mt-5">
        {/* Step counter */}
        <span className="text-greyModerate text-xs">
          {index + 1} of {size}
        </span>

        {/* Buttons */}
        <div className="flex items-center gap-2">
          {/* Skip button - only show if not continuous or if there are more steps */}
          {!isLastStep && (
            <button
              {...skipProps}
              className="text-greyModerate text-sm hover:text-blackLight transition-colors mr-2"
            >
              Skip
            </button>
          )}

          {/* Back button */}
          {index > 0 && (
            <Button
              {...backProps}
              color="light"
              size="sm"
              className="border-greyLight text-blackLight hover:bg-greyLightest"
            >
              Back
            </Button>
          )}

          {/* Next/Finish button */}
          {continuous && (
            <Button
              {...primaryProps}
              size="sm"
              className="bg-primary-700 hover:bg-primary-800 text-white"
            >
              {isLastStep ? 'Finish' : 'Next'}
            </Button>
          )}

          {/* Close button for non-continuous tours */}
          {!continuous && (
            <Button
              {...closeProps}
              size="sm"
              className="bg-primary-700 hover:bg-primary-800 text-white"
            >
              Close
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};
